import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useI18n } from '../i18n'
import { useAcceptInvite } from '../api/hooks'
import type { Farm } from '@horsehub/shared'

export function InviteAccept() {
  const { token = '' } = useParams()
  const { t } = useI18n()
  const accept = useAcceptInvite()
  const [farm, setFarm] = useState<Farm | null>(null)
  const [error, setError] = useState(false)

  const onAccept = () => {
    setError(false)
    accept.mutate(token, {
      onSuccess: (res) => setFarm(res.farm),
      onError: () => setError(true),
    })
  }

  if (farm) {
    return (
      <main className="mx-auto max-w-md px-5 py-16 text-center">
        <div className="card p-8">
          <div className="text-5xl">🎉</div>
          <h1 className="mt-4 text-2xl font-extrabold tracking-tight">{t('farm.accept.doneTitle', { farm: farm.name })}</h1>
          <p className="mt-2 text-brand-600 dark:text-brand-300">{t('farm.accept.doneBody')}</p>
          <Link to="/my-farm" className="btn-primary mt-6">{t('farm.accept.goApp')}</Link>
        </div>
      </main>
    )
  }

  if (error) {
    return (
      <main className="mx-auto max-w-md px-5 py-16 text-center">
        <div className="card p-8">
          <div className="text-5xl">🔗</div>
          <h1 className="mt-4 text-2xl font-extrabold tracking-tight">{t('farm.accept.invalid')}</h1>
          <p className="mt-2 text-brand-600 dark:text-brand-300">{t('farm.accept.invalidBody')}</p>
          <Link to="/app" className="btn-primary mt-6">{t('farm.accept.goApp')}</Link>
        </div>
      </main>
    )
  }

  return (
    <main className="mx-auto max-w-md px-5 py-16 text-center">
      <div className="card p-8">
        <div className="text-5xl">🏡</div>
        <h1 className="mt-4 text-2xl font-extrabold tracking-tight">{t('farm.accept.heading')}</h1>
        <p className="mt-2 text-brand-600 dark:text-brand-300">{t('farm.accept.body')}</p>
        <button onClick={onAccept} disabled={accept.isPending} className="btn-primary mt-6 disabled:opacity-60">
          {accept.isPending ? t('farm.accept.busy') : t('farm.accept.cta')}
        </button>
      </div>
    </main>
  )
}
